<main class="not-found" aria-labelledby="not-found-title">
  <p class="status">404</p>
  <h1 id="not-found-title">Page not found</h1>
  <p>The requested page does not exist.</p>
  <a routerLink="/">Return home</a>
</main>